module.exports = __webpack_public_path__ + "img/zgzpt2.1a721123.png";